import { Injectable } from '@angular/core';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private readonly authService: AuthService) {
  }


  getRoles(): string[] {

    return this.authService.getRoles();

  }

}
